module.exports = __webpack_public_path__ + "static/media/27_B.9967b2e6.png";